<div class="gpd-full-page contract-template-settings">
  <!-- Save/Cancel, top right — visible state mirrors the review-settings tab -->
  <div class="page-actions">
    <app-gpd-button
      type="secondary"
      text="Cancel"
      i18n-text="@@cancel"
      (onClick)="cancel()"
      [disabled]="!hasChanges || isSaving"
    ></app-gpd-button>
    <app-gpd-button
      type="default"
      icon="tick"
      text="Save"
      i18n-text="@@save"
      (onClick)="save()"
      [disabled]="!hasChanges || isSaving"
    ></app-gpd-button>
  </div>

  <div class="gpd-config-section">
    <div class="gpd-config-section-header">
      <div>
        <div class="gpd-config-section-title">
          <span i18n="@@contractTemplateSection">Template</span>
        </div>
        <div
          class="gpd-config-section-description"
          i18n="@@contractTemplateSectionDescription"
        >
          Select a folder to display only the relevant contract templates.
        </div>
      </div>
    </div>
    <div class="gpd-config-section-content">
      <div class="setting-row">
        <label i18n="@@templateFolder">Template folder</label>
        <dx-drop-down-box
          class="folder-picker"
          [(opened)]="folderDropDownOpened"
          [value]="selectedFolderLabel"
          [showClearButton]="true"
          [acceptCustomValue]="true"
          [disabled]="isLoading"
          i18n-placeholder="@@selectFolderPlaceholder"
          placeholder="Select a folder..."
          (onValueChanged)="onFolderFieldValueChanged($event)"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              class="folder-tree"
              [items]="folderTree"
              dataStructure="plain"
              keyExpr="id"
              parentIdExpr="parentId"
              displayExpr="name"
              [searchEnabled]="true"
              searchMode="contains"
              selectionMode="single"
              itemTemplate="folderTreeItem"
              (onItemClick)="selectFolder($event.itemData)"
            >
              <div *dxTemplate="let node of 'folderTreeItem'" class="folder-tree-item">
                <app-svg-icon icon="folder" [size]="16"></app-svg-icon>
                <span class="folder-tree-item-name">{{ node.name }}</span>
              </div>
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </div>
    </div>
  </div>
</div>
